import client from "utils/api";

function getAdventure(uuid){
  return client().get("/accounts/public/"+uuid)
  .then((response) => {
      return response.data
  })
}

export default {
  getAdventure
}



// WEBPACK FOOTER //
// ./src/components/adventures/public/api.js